import { observer } from 'mobx-react-lite';
import { useCreateStore, useProvider } from 'mobx-store-provider';
import { nanoid } from 'nanoid';
import * as React from 'react';

import { useDoExerciseProgressStore } from '../../../../shared-components/Exercise/do-exercise-progress-store.store';
import { ExerciseQuizDoTestStore } from '../../store/exercise-quiz-do-test.store';
import { DoTestExerciseQuizProps } from '../../types';

export const DoTestExerciseQuiz = observer((props: DoTestExerciseQuizProps) => {
  const { attributes, children, element } = props;

  const pageExerciseStore = useDoExerciseProgressStore();
  const externalStore = pageExerciseStore?.quizStores.get(element.id);
  const internalStore = useCreateStore(ExerciseQuizDoTestStore, {
    id: element?.id || nanoid(),
    isLoginRequired: element.isLoginRequired,
    quizIds: element?.children?.[0]?.children?.map((it) => it.id),
    currentQuizIndex: externalStore?.userAnswers?.size || 0,
    element,
  });

  /** Set data from internalStore -> externalStore */
  React.useEffect(() => {
    if (!externalStore && internalStore && pageExerciseStore) {
      const internalStoreState = internalStore.preparePayload() as any;
      pageExerciseStore.init([{ ...internalStoreState, element }]);
    }
  }, [externalStore, pageExerciseStore, internalStore, element.children, element]);

  // Init quizIds for external store
  React.useEffect(() => {
    if (externalStore && externalStore.quizIds.length === 0) {
      externalStore.setQuizIds(element?.children?.[0]?.children?.map((it) => it.id));
    }
  }, [element?.children, externalStore]);

  const Provider = useProvider(ExerciseQuizDoTestStore);
  const isValid = true;

  return (
    <Provider value={externalStore ?? internalStore}>
      <div className="font-inter" {...attributes}>
        {isValid ? children : null}
      </div>
    </Provider>
  );
});
